import { useEffect, useState } from "react";
import CampaignService from "../services/CampaignService";

/**
 * Provides the known sub-functional-unit display names
 * (decrypted campaign_mapping.sub_functional_unit_name) used by PII
 * detection to flag a sub-functional unit's name typed into coaching-form
 * fields (COACH-2113).
 */
const useSubFunctionalUnitNames = () => {
  const [subFunctionalUnitNames, setSubFunctionalUnitNames] = useState([]);

  useEffect(() => {
    let active = true;
    CampaignService.getKnownSubFunctionalUnitNames().then(names => {
      if (active) setSubFunctionalUnitNames(names);
    });
    return () => {
      active = false;
    };
  }, []);

  return subFunctionalUnitNames;
};

export default useSubFunctionalUnitNames;
